'use client'

import { useLocale, useTranslations } from 'next-intl'
import { useTransition } from 'react'

import { setLocale } from '@/i18n/actions'
import { LOCALES, LOCALE_LABELS, type Locale } from '@/i18n/locales'

/**
 * Switches the language of the whole interface.
 *
 * A plain select rather than a flag menu: a flag names a country, not a
 * language, and Portuguese is spoken in more than one of them. Each language is
 * written in itself, so somebody who landed in the wrong one can still read
 * their way out.
 */
export function LanguageSwitcher() {
  const current = useLocale()
  const t = useTranslations('language')
  const [pending, startTransition] = useTransition()

  return (
    <label className="flex items-center gap-2 text-sm text-gray-500">
      <span className="sr-only">{t('change')}</span>
      <select
        aria-label={t('change')}
        value={current}
        disabled={pending}
        onChange={event => {
          const next = event.target.value as Locale
          startTransition(async () => {
            await setLocale(next)
          })
        }}
        className="rounded-lg border border-gray-200 bg-gray-50 py-1.5 pl-2 pr-7 text-sm text-gray-700 transition-all focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 disabled:opacity-50"
      >
        {LOCALES.map(locale => (
          <option key={locale} value={locale}>
            {LOCALE_LABELS[locale]}
          </option>
        ))}
      </select>
    </label>
  )
}
